import axios from "axios";
import { ArrowUpDown, Download } from "lucide-react";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "sonner";
import { DataTable } from "src/components/DataTable";
import { Button } from "src/components/ui/button";
import LoaderPage from "../../../../../components/LoaderPage.jsx";
import { useAuth } from "../../../../../context/AuthContext.jsx";
import { useLanguage } from "../../../../../context/LanguageContext.jsx";
import { BaseUrlApi, ErrorMessage, UrlImage } from "../../../../../lib/api.js";
import { SubLessonData } from "../../../../../lib/languages.js";
import DrawerQuizShowAnswer from "../Quiz/DrawerQuizShowAnswer.jsx";

export default function ShowHomeworkAnswer() {
  // Id
  const { id: assignmentId } = useParams();
  const { state } = useLocation();
  const lessonId = state?.lessonId;

  const { user } = useAuth();
  const navigate = useNavigate();

  const { language } = useLanguage();
  const t = SubLessonData[language] || SubLessonData["en"];

  // Attempt Homework
  const [loadingAttemptHomework, setLoadingAttemptHomework] = useState(false);
  const [attemptHomework, setAttemptHomework] = useState([]);

  const getAllAttemptHomework = async () => {
    try {
      const { data } = await axios.get(
        `${BaseUrlApi}/lesson/${lessonId}/all-answer/${assignmentId}`
      );
      setAttemptHomework(data.data);
    } catch (error) {
      toast("Error", {
        description: ErrorMessage(error),
      });
    } finally {
      setLoadingAttemptHomework(false);
    }
  };

  useEffect(() => {
    setLoadingAttemptHomework(true);
    getAllAttemptHomework();
  }, [assignmentId]);

  if (loadingAttemptHomework) {
    return <LoaderPage title={t.loadingHomeworkQuiz} />;
  }

  const columns = [
    {
      accessorKey: `user_id.name`,
      header: ({ column }) => (
        <Button
          variant="ghost"
          className="p-0 hover:bg-transparent"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          {t.name}
          <ArrowUpDown className="h-4 w-4" />
        </Button>
      ),
    },
    {
      accessorKey: "user_id.email",
      header: t.email,
    },
    {
      accessorKey: "user_id.phone",
      header: t.phone,
    },
    {
      accessorKey: "score",
      header: ({ column }) => (
        <Button
          variant="ghost"
          className="p-0 hover:bg-transparent"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          {t.score}
          <ArrowUpDown className="h-4 w-4" />
        </Button>
      ),
      cell: ({ row }) => {
        const item = row.original;
        return item.score || 0;
      },
    },
    {
      id: "actions",
      header: t.showAnswers,
      cell: ({ row }) => {
        const item = row.original;
        return (
          <Button size="sm" className="text-primary" asChild>
            <a
              href={`${UrlImage}${item.file}`}
              download="myfile.pdf"
              target="_blank"
            >
              <Download className="h-4 w-4 text-background" />
            </a>
          </Button>
        );
      },
    },
  ];

  return (
    <div className="space-y-10" dir={language === "ar" ? "rtl" : "ltr"}>
      <div>
        <div className="text-2xl font-bold">{t.quizHomeworksTitle}</div>
        <DataTable
          columns={columns}
          data={attemptHomework}
          title={t.usersByName}
          filterNames={["user_id_name", "user_id_email", "score"]}
        />
      </div>
    </div>
  );
}
